import { type Router } from 'vue-router';
import { useAuthStore } from '../stores/auth.store';
import { isPromise } from '../../../utils';

export const createAuthGuard = (router: Router, loginRouteName: string, homeRouteName = 'personList') => {
  router.beforeEach(async (to) => {
    const authStore = useAuthStore();
    const tempAllowRoute = 'persons';

    if (authStore.initializingPromise && isPromise(authStore.initializingPromise) && (to.name !== loginRouteName || to.name !== tempAllowRoute)) {
      await authStore.initializingPromise;
    }

    // check if authentication is required and user is logged in
    if (!to.meta.requiresAuth) return;

    if (to.name != loginRouteName && !authStore.loggedIn) {
      return { name: loginRouteName, query: { redirect: to.fullPath } };
    }

    // check permissions
    const routePermissions = to.meta.permission;
    if (!routePermissions || !routePermissions.length || authStore.hasPermission(routePermissions)) return;

    return { name: homeRouteName };
  });
};
